import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const styles = (theme: Theme) => {

	return createStyles({
		mockForm_1_addressPopup_formContainer: {

		},
		mockForm_1_addressPopup_checkboxListContainer: {
			display: 'inline-flex',
			flexDirection: 'column',
			width: '100%',
			margin: theme.spacing(3, 0)
		},
		mockForm_1_addressPopup_checkboxListBody: {
			display: 'inline-flex',
			flexWrap: 'wrap',
		},
		mockForm_1_addressPopup_checkboxListLabel: {	
			lineHeight: theme.typography.subtitle2.lineHeight,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0, 0, 1, 1.5),
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				padding: theme.spacing(0, 0, 0, 1.5),
			},
		},
		mockForm_1_addressPopup_checkboxListHelperText: {
			padding: theme.spacing(1, 0, 0, 1.5),
		},
		mockForm_1_addressPopup_checkboxContainer: {
			[theme.breakpoints.up(BreakpointWidth.X_LARGE)]: {
				width: `${100 / 6}%`,
			},
			[theme.breakpoints.between(BreakpointWidth.LARGE, BreakpointWidth.X_LARGE)]: {
				width: `${100 / 4}%`
			},
			[theme.breakpoints.between(BreakpointWidth.MEDIUM, BreakpointWidth.LARGE)]: {
				width: `${100 / 3}%`
			},
			[theme.breakpoints.down(BreakpointWidth.MEDIUM)]: {
				width: `${100 / 2}%`,
			},
		},
		mockForm_1_addressPopup_checkboxBody: {
			padding: theme.spacing(2, 1.5),
		},
		mockForm_1_addressPopup_addressContainer: {
			display: 'flex',
			flexDirection: 'column',
			marginBottom: theme.spacing(3),
		},
		mockForm_1_addressPopup_addressLabel: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			fontSize: theme.typography.h6.fontSize,
			margin: theme.spacing(0, 0, 0, 1.5),
		},
		mockForm_1_addressPopup_wholeRow: {
			padding: theme.spacing(3, 0),
			width: '100%',
			display: 'flex',
			flexWrap: 'wrap',
		},
		mockForm_1_addressPopup_wholeRowColumn: {
			padding: theme.spacing(0, 1.5),
			width: '100%',
		},
		mockForm_1_addressPopup_duoRow: {
			width: '100%',
			display: 'flex',
			flexWrap: 'wrap',
		},
		mockForm_1_addressPopup_duoRowColumnContainer: {
			margin: theme.spacing(3, 0),
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				width: `50%`
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				width: `100%`
			},
		},
		mockForm_1_addressPopup_duoRowColumn: {
			padding: theme.spacing(0, 1.5),
		}
	});
}

export default styles;
